Shopify.queue = [];
Shopify.moveAlong = function (redirect) {
  var redirect = redirect || false;
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift();
    if (request.type == 'remove') {
      var url = '/cart/change.js';
    } else {
      var url = '/cart/add.js';
    }
    var data = {
      quantity: request.quantity,
      id: request.id,
    };
    if (request.properties) {
      data.properties = request.properties;
    }
    var hasAlerted = false;
    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      error: function (data) {
        var data = $.parseJSON(data.responseText);
        if (!!data.message) {
          if (data.status == 422) {
            alert(data.description);
            Shopify.moveAlong(redirect);
          }
        }
      },
      complete: function () {
        Shopify.moveAlong(redirect);
      },
    });
  } else {
    if (redirect) {
      window.location = redirect;
    }
  }
};
window.requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();
window.scrollToY = function (scrollTargetY, speed, easing) {
  var scrollY = window.scrollY || document.documentElement.scrollTop,
    scrollTargetY = scrollTargetY || 0,
    speed = speed || 2000,
    easing = easing || 'easeOutSine',
    currentTime = 0;
  var time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8));
  var easingEquations = {
    easeOutSine: function (pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: function (pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: function (pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2);
    },
  };

  function tick() {
    currentTime += 1 / 60;
    var p = currentTime / time;
    var t = easingEquations[easing](p);
    if (p < 1) {
      requestAnimFrame(tick);
      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }
  tick();
};

var productslider = Array.prototype.slice.call(document.querySelectorAll('[data-product-slider]'));
var sliders = Array.prototype.slice.call(document.querySelectorAll('[data-collection-slider]'));
var articlesliders = Array.prototype.slice.call(document.querySelectorAll('[data-article-slider]'));

doProductSlider = function (slider) {
  console.log('Slider Dataset', slider.dataset.count);
  var mode = slider.dataset.fade == 'true' ? 'gallery' : 'carousel';
  var tinySlider = tns({
    container: slider,
    mode: mode,
    slideBy: slider.dataset.slideBy ? parseInt(slider.dataset.slideBy) : 'page',
    items: parseInt(slider.dataset.show),
    controls: true,
    gutter: slider.dataset.gutter,
    loop: true,
    nav: slider.dataset.dots == 'false',
    navContainer: slider.dataset.count > 1 ? '#thumbnails-wrap': undefined,
    navAsThumbnails: true,
    speed: parseFloat(slider.dataset.speed) * 1000,
    animateDelay: parseFloat(slider.dataset.aspeed) * 1000,
    autoplay: slider.dataset.autoplay == 'true',
    autoplayHoverPause: false,
    animateIn: 'tns-fadeIn',
    animateOut: 'tns-fadeOut',
    autoplayButton: false,
    autoplayButtonOutput: false,

    onInit: function (info) {
      // var count = info.slideCount
      var prevArrow = info.prevButton;
      var nextArrow = info.nextButton;
      prevArrow.addEventListener('click', function () {
        if (this.getAttribute('aria-disabled') == 'true') {
          tinySlider.goTo('last');
        }
      });
      nextArrow.addEventListener('click', function () {
        if (this.getAttribute('aria-disabled') == 'true') {
          tinySlider.goTo('first');
        }
      });
      if (slider.style.visibility === 'hidden') {
        slider.style.visibility = 'visible';
      }
    },
    responsive: {
      1024: {
        items: parseInt(slider.dataset.show),
        disable: slider.dataset.mobileonly == 'true',
      },
      768: {
        items: parseInt(slider.dataset.showTablet || slider.dataset.show || 4),
        disable: slider.dataset.mobileonly == 'true',
      },
      0: {
        items: parseInt(slider.dataset.showMobile || 2),
      },
    },
  });
};

doSlider = function (slider) {
  var mode = slider.dataset.fade == 'true' ? 'gallery' : 'carousel';
  var tinySlider = tns({
    container: slider,
    mode: mode,
    slideBy: slider.dataset.slideBy ? parseInt(slider.dataset.slideBy) : 'page',
    items: parseInt(slider.dataset.show),
    controls: true,
    gutter: slider.dataset.gutter,
    loop: true,
    nav: slider.dataset.dots == 'true',
    // navContainer: '#thumbnails-wrap',
    // navAsThumbnails: true,
    speed: parseFloat(slider.dataset.speed) * 1000,
    animateDelay: parseFloat(slider.dataset.aspeed) * 1000,
    autoplay: slider.dataset.autoplay == 'true',
    autoplayHoverPause: false,
    animateIn: 'tns-fadeIn',
    animateOut: 'tns-fadeOut',
    autoplayButton: false,
    autoplayButtonOutput: false,
    
    onInit: function (info) {
      var prevArrow = info.prevButton;
      var nextArrow = info.nextButton;
      prevArrow.addEventListener('click', function () {
        if (this.getAttribute('aria-disabled') == 'true') {
          tinySlider.goTo('last');
        }
      });
      nextArrow.addEventListener('click', function () {
        if (this.getAttribute('aria-disabled') == 'true') {
          tinySlider.goTo('first');
        }
      });
      if (slider.style.visibility === 'hidden') {
        slider.style.visibility = 'visible';
      }
    },
    responsive: {
      1024: {
        items: parseInt(slider.dataset.show),
        disable: slider.dataset.mobileonly == 'true',
      },
      768: {
        items: parseInt(slider.dataset.showTablet || slider.dataset.show || 4),
        disable: slider.dataset.mobileonly == 'true',
      },
      0: {
        items: parseInt(slider.dataset.showMobile || 2),
      },
    },
  });
};

doArticleSlider = function (slider) {
  var mode = slider.dataset.fade == 'true' ? 'gallery' : 'carousel';
  var tinySlider = tns({
    container: slider,
    mode: mode,
    slideBy: slider.dataset.slideBy ? parseInt(slider.dataset.slideBy) : 'page',
    items: parseInt(slider.dataset.show),
    controls: true,
    gutter: slider.dataset.gutter,
    loop: false,
    nav: slider.dataset.dots == 'true',
    // navContainer: '#thumbnails-wrap',
    // navAsThumbnails: true,
    speed: parseFloat(slider.dataset.speed) * 1000,
    animateDelay: parseFloat(slider.dataset.aspeed) * 1000,
    autoplay: slider.dataset.autoplay == 'true',
    autoplayHoverPause: false,
    animateIn: 'tns-fadeIn',
    animateOut: 'tns-fadeOut',
    autoplayButton: false,
    autoplayButtonOutput: false,
  });
};

removeSlider = function () {};


for (var i = 0; i < productslider.length; i += 1) {
  (function (i) {
    var slider = productslider[i];
    doProductSlider(slider);
  })(i);
}

for (var i = 0; i < sliders.length; i += 1) {
  (function (i) {
    var slider = sliders[i];
    doSlider(slider);
  })(i);
}

for (var i = 0; i < articlesliders.length; i += 1) {
  (function (i) {
    var slider = articlesliders[i];
    doArticleSlider(slider);
  })(i);
}

var checkboxProducts = document.querySelectorAll('[data-checkbox-prod-wrapper]');
for (var i = 0; i < checkboxProducts.length; i += 1) {
  var prod = checkboxProducts[i];
  var labels = prod.querySelectorAll('label');
  var input = prod.querySelector("input[type='checkbox']");
  var randomNumber = Math.floor(Math.random() * 1000);
  if (input) {
    input.setAttribute('id', input.getAttribute('id') + randomNumber);
  }
  for (var j = 0; j < labels.length; j += 1) {
    labels[j].setAttribute('for', labels[j].getAttribute('for') + randomNumber);
  }
}
var mobile_menu_div = document.querySelector('.mobile-navigation');

if (mobile_menu_div) {
  var mobileDropdownAnchors = mobile_menu_div.querySelectorAll('a:not(.dropdown)');
}
if (mobileDropdownAnchors) {
  for (var i = 0; i < mobileDropdownAnchors.length; i += 1) {
    mobileDropdownAnchors[i].addEventListener('click', function (e) {
      window.scrollTo(0, 0);
      mobile_menu_trigger.classList.remove('open');
      mobile_menu_div.classList.remove('open');
    });
  }
}
if (mobile_menu_div) {
  var mobileDropdownTrigger = mobile_menu_div.querySelectorAll('.dropdown');
}
if (mobileDropdownTrigger) {
  for (var i = 0; i < mobileDropdownTrigger.length; i += 1) {
    (function () {
      var trigger = mobileDropdownTrigger[i];
      var dropdown = trigger.nextElementSibling;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('open');
        if (this.classList.contains('open')) {
          var height = dropdown.scrollHeight;
          dropdown.style.height = height + 'px';
        } else {
          dropdown.style.height = '0px';
        }
      });
    })(i);
  }
}
var accordions = document.querySelectorAll('.accordion-header');

updateAccordions = function () {
  var openAccordions = document.querySelectorAll('.accordion-item.open > .accordion-content');
  for (var i = 0; i < openAccordions.length; i++) {
    openAccordions[i].style.height = openAccordions[i].scrollHeight + 'px';
  }
};

updateAccordions();

updateParentAccordions = function (accordion) {
  var accordionParent = accordion.parentNode.parentNode.parentNode;
  
  if (accordionParent.parentNode.classList.contains('open')) {
    accordionParent.style.maxHeight = '0px';
    accordionParent.style.height = accordionParent.scrollHeight + 'px';
    accordionParent.style.maxHeight = 'none';
  }
  if (accordionParent.classList.contains('accordion-content')) {
    updateParentAccordions(accordionParent);
  }
};

for (var i = 0; i < accordions.length; i++) {
  var accordionHeader = accordions[i];
  accordionHeader.addEventListener('click', function (e) {
    e.preventDefault();
    var parent = this.parentNode;
    var content = this.nextElementSibling;
    var isOpen = parent.classList.contains('toggle') ? false : parent.classList.contains('open')

    var openElements = jQuery(this).closest('.accordion').find('.open:not(.toggle)');
    if (openElements.length) {
      for (var i = 0; i < openElements.length; i++) {
        var item = openElements[i]
        jQuery(item).removeClass('open');
        jQuery(item).find('.accordion-content').css('height', '0px');
      }
    }

    if( isOpen == false ) {
      parent.classList.toggle('open');
      content.style.height = (parent.classList.contains('open') ? content.scrollHeight : 0) + 'px';
    }
    
    updateParentAccordions(content);
  });
}

if (document.querySelectorAll('select.choices-select').length > 0) {
  var choice = new Choices('select.choices-select', {
    searchEnabled: false,
    removeItems: false,
    paste: false,
    itemSelectText: '',
    shouldSort: false,
  });
}

var quantitySelectors = document.querySelectorAll('[data-quantity-selector]');
for (var i = 0; i < quantitySelectors.length; i += 1) {
  (function (i) {
    var selector = quantitySelectors[i];
    var minusButton = selector.querySelector('[data-quantity-minus]');
    var plusButton = selector.querySelector('[data-quantity-plus]');
    var input = selector.querySelector('input');
    var min;
    var max;
    var doLimits = function () {
      min = input.dataset.min ? parseInt(input.dataset.min) : 1;
      max = input.dataset.max ? parseInt(input.dataset.max) : Infinity;
    };
    doLimits();
    minusButton.addEventListener('click', function (e) {
      doLimits();
      e.preventDefault();
      if (parseInt(input.value) - 1 < min) {
        return false;
      }
      input.value = parseInt(input.value) - 1;
      var event = document.createEvent('HTMLEvents');
      event.initEvent('input', true, false);
      input.dispatchEvent(event);
    });
    plusButton.addEventListener('click', function (e) {
      doLimits();
      e.preventDefault();
      if (parseInt(input.value) + 1 > max) {
        return false;
      }
      input.value = parseInt(input.value) + 1;
      var event = document.createEvent('HTMLEvents');
      event.initEvent('input', true, false);
      input.dispatchEvent(event);
    });
    input.addEventListener('input', function (e) {
      doLimits();
      if (parseInt(this.value) <= min) {
        this.value = min;
      }
      if (parseInt(this.value) >= max) {
        this.value = max;
      }
      if (isNaN(parseInt(this.value))) {
        this.value = min;
      }
    });
    input.addEventListener('touchstart', function (e) {
      return false;
    });
  })(i);
}
var inputs = document.querySelectorAll('textarea, input');
for (var i = 0; i < inputs.length; i += 1) {
  if (inputs[i].value.length > 0) {
    inputs[i].classList.add('has-value');
    inputs[i].classList.add('has-had-value');
  } else {
    inputs[i].classList.remove('has-value');
  }
  inputs[i].addEventListener('input', function () {
    if (this.value.length > 0) {
      this.classList.add('has-value');
      this.classList.add('has-had-value');
    } else {
      this.classList.remove('has-value');
    }
  });
}
rivets.formatters.getSizedImage = function (src, size) {
  return slate.Image.getSizedImageUrl(src, size);
};
rivets.formatters.moneyNoSymbol = function (value) {
  return value / 100.0;
};
rivets.formatters.money = function (value) {
  return slate.Currency.formatMoney(value, theme.moneyFormat);
};
rivets.formatters.getSize = function (item) {
  if (item.variant_title) {
    return 'Size: ' + item.variant_title;
  }
  return '';
};
rivets.formatters.getURL = function (item) {
  if (item.line_price == 0) {
    return '#';
  } else {
    return item.url;
  }
};
rivets.formatters.plural = function (count) {
  return count == 1 ? 'item' : 'items';
};
rivets.formatters.isSelected = function (quantity, item) {
  return item.quantity == parseInt(quantity);
};
rivets.formatters.json = function (value) {
  return JSON.stringify(value);
};
rivets.formatters.getActions = function (product) {
  return product.metafields['esc.actionsSummary'] ? product.metafields['esc.actionsSummary'] : product.metafields['esc.actions'];
};
rivets.binders['background'] = function (el, value) {
  el.style.setProperty('background-image', "url('" + value + "')");
};
// var popoutCart = document.querySelector('.popout-cart');
// var popoutCartTrigger = document.querySelector('.open-popout-cart');
// var toIgnore = ['open-popout-cart', 'search-trigger'];
// popoutCartTrigger.addEventListener('click', function (e) {
//   popoutCartTrigger.classList.toggle('open');
// });
var popup = document.querySelector('.popup-overlay');
var popupClose = popup.querySelector('.close-overlay');
var scrollToLinks = document.querySelectorAll('[data-scroll-to]');
for (var i = 0; i < scrollToLinks.length; i += 1) {
  scrollToLinks[i].addEventListener('click', function (e) {
    e.preventDefault();
    var toScroll = this.dataset.scrollTo;
    var elem = document.querySelector(toScroll);
    if (elem) {
      scrollToY(elem.getBoundingClientRect().top, 500);
    }
  });
}
var hasParent = function (node, classArr) {
  for (var i = 0; i < node.classList.length; i += 1) {
    if (classArr.indexOf(node.classList[i]) != -1) {
      return true;
    }
  }
  if (node.parentNode && node.parentNode !== document) {
    return hasParent(node.parentNode, classArr);
  }
  return false;
};
var getParent = function (el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls)) {}
  return el;
};
var documentClick = function (e) {
  var clickedIgnore = hasParent(e.target, toIgnore);
  if (!clickedIgnore) {
    popoutCartTrigger.classList.remove('open');
    var headerSearchTrigger = document.querySelector('.search button');
    var headerSearchForm = document.querySelector('.search form');
    if (headerSearchForm) {
      headerSearchForm.classList.remove('open');
    }
    if (headerSearchTrigger) {
      headerSearchTrigger.setAttribute('type', 'button');
    }
  }
  if (e.target.hasAttribute('data-ga-event')) {
    var gaData = JSON.parse(e.target.dataset.gaEvent);
    console.log(gaData);
    ga('send', {
      hitType: 'event',
      eventCategory: gaData.category,
      eventAction: gaData.action,
      eventLabel: gaData.label,
      transport: gaData.transport || 'xhr',
    });
  }
};
var gaEventForms = document.querySelectorAll('form[data-ga-event]');
for (var i = 0; i < gaEventForms.length; i += 1) {
  gaEventForms[i].addEventListener('submit', function (e) {
    var gaData = JSON.parse(this.dataset.gaEvent);
    console.log(gaData);
    ga('send', {
      hitType: 'event',
      eventCategory: gaData.category,
      eventAction: gaData.action,
      eventLabel: gaData.label,
      transport: gaData.transport || 'xhr',
    });
  });
}
document.addEventListener('click', documentClick);
document.addEventListener('touchstart', documentClick);
var cartQuantitySelect = document.querySelectorAll('[data-cart-qty-input]');
for (var i = 0; i < cartQuantitySelect.length; i += 1) {
  var select = cartQuantitySelect[i];
  select.addEventListener('input', function () {
    window.location = '/cart/change?id=' + this.dataset.line + '&amp;quantity=' + this.value;
  });
}
var headerSearchTrigger = document.querySelector('.search button');
var headerSearchForm = document.querySelector('.search form');
if (headerSearchTrigger) {
  headerSearchTrigger.addEventListener('click', function (e) {
    var form = this.parentNode;
    var input = this.previousElementSibling;
    if (input.value.length > 0) {
      return false;
    } else {
      e.preventDefault();
    }
    form.classList.toggle('open');
    if (form.classList.contains('open')) {
      this.setAttribute('type', 'submit');
      setTimeout(function () {
        input.focus();
      }, 350);
    } else {
      this.setAttribute('type', 'button');
    }
  });
}
document.addEventListener('DOMContentLoaded', function () {
  var toFocus = document.querySelector('.js-ios-scroll-fix');
  if (toFocus && window.innerWidth < 768) {
    window.scrollTo(0, toFocus.scrollHeight);
  }
});
var tabs = document.querySelectorAll('[data-tabs]');
for (var i = 0; i < tabs.length; i += 1) {
  (function () {
    var tabContainer = tabs[i];
    var tabNav = tabContainer.querySelector('[data-tabs-header]');
    var tabContent = tabContainer.querySelector('[data-tabs-content]');
    var tabContentAreas = tabContent.querySelectorAll('.tab');
    var tabNavAnchor = tabNav.querySelectorAll('a');
    for (var j = 0; j < tabNavAnchor.length; j += 1) {
      var anchor = tabNavAnchor[j];
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        var parentLi = this.parentNode;
        var tabIndex = parentLi.dataset.tab;
        for (var k = 0; k < tabNavAnchor.length; k += 1) {
          tabNavAnchor[k].parentNode.classList.remove('active');
        }
        parentLi.classList.add('active');
        for (var k = 0; k < tabContentAreas.length; k += 1) {
          tabContentAreas[k].classList.add('faded');
        }
        setTimeout(function () {
          for (var k = 0; k < tabContentAreas.length; k += 1) {
            tabContentAreas[k].classList.remove('active');
          }
          tabContent.querySelector('[data-tab="' + tabIndex + '"]').classList.add('active');
          if (window.innerWidth <= 768) {
            scrollToY(tabContent.getBoundingClientRect().top + window.scrollY - 350, 500);
          }
          setTimeout(function () {
            tabContent.querySelector('[data-tab="' + tabIndex + '"]').classList.remove('faded');
          }, 100);
        }, 100);
      });
    }
  })(i);
}
var doTabHash = function () {
  if (location.hash && location.hash.includes('#tab')) {
    var tabIndex = location.hash.replace('#tab', '').trim().match(/\d+/)[0];
    var anchor = document.querySelector("[data-tab='" + tabIndex + "'] a");
    var event = document.createEvent('HTMLEvents');
    event.initEvent('click', false, true);
    if (anchor) {
      anchor.dispatchEvent(event);
      scrollToY(anchor.getBoundingClientRect().top - 70);
    }
  }
};
doTabHash();
window.onhashchange = doTabHash;
var allMenuAnchors = document.querySelectorAll('.main-nav .site-nav a');
var menuAnchors = document.querySelectorAll('.main-nav .site-nav a.has-sub');
var initialSub = document.querySelector('.header-sub-nav .initial');
var headerSubs = document.querySelectorAll('.header-sub-nav > ul');
var activeHref = document.querySelector('.main-nav .site-nav li.active a');
for (var i = 0; i < allMenuAnchors.length; i += 1) {
  var anchor = allMenuAnchors[i];
  anchor.addEventListener('click', function () {
    for (var j = 0; j < allMenuAnchors.length; j += 1) {
      allMenuAnchors[j].parentNode.classList.remove('active');
    }
    this.parentNode.classList.add('active');
  });
}
var headerMouseLeave = function (e) {
  if (initialSub) {
    for (var j = 0; j < headerSubs.length; j += 1) {
      headerSubs[j].classList.remove('shown');
    }
    initialSub.classList.add('shown');
  } else {
    var sub = activeHref.dataset.sub;
    for (var j = 0; j < headerSubs.length; j += 1) {
      headerSubs[j].classList.remove('shown');
    }
    var subNav = document.querySelector('.header-sub-nav > [data-sub="' + sub + '"]');
    if (subNav) {
      subNav.classList.add('shown');
    }
  }
};
for (var i = 0; i < menuAnchors.length; i += 1) {
  menuAnchors[i].addEventListener('mouseenter', function (e) {
    var sub = this.dataset.sub;
    for (var j = 0; j < headerSubs.length; j += 1) {
      headerSubs[j].classList.remove('shown');
    }
    var theSub = document.querySelector('.header-sub-nav > [data-sub="' + sub + '"]');
    if (theSub) {
      theSub.classList.add('shown');
    }
  });
  menuAnchors[i].addEventListener('mouseleave', function (e) {
    var goingto = e.toElement || e.relatedTarget;
    if (goingto.classList.contains('header-sub-nav') || hasParent(goingto, 'header-sub-nav')) {
      return false;
    }
    headerMouseLeave(e);
  });
}
for (var i = 0; i < headerSubs.length; i += 1) {
  headerSubs[i].addEventListener('mouseleave', function (e) {
    this.classList.remove('shown');
    if (initialSub) {
      initialSub.classList.add('shown');
    }
  });
}

var overlayTrigger = document.querySelector('.video-trigger');
var videoOverlay = document.querySelector('.video-overlay');
if (overlayTrigger && videoOverlay) {
  overlayTrigger.addEventListener('click', function (e) {
    e.preventDefault();
    videoOverlay.classList.add('open');
    var vid = videoOverlay.querySelector('video');
    if (vid) {
      vid.play();
    }
  });
  videoOverlay.addEventListener('click', function (e) {
    e.preventDefault();
    if (e.target == this) {
      videoOverlay.classList.remove('open');
      var vid = videoOverlay.querySelector('video');
      if (vid) {
        vid.pause();
      }
    }
  });
}
var products = document.querySelectorAll('.product-grid-item');
document.addEventListener('click', function (e) {
  if (e.target && e.target.classList.contains('popup-trigger')) {
    e.preventDefault();
    var product = getParent(e.target, 'product-grid-item');
    var jsonScript = product.querySelector("[data-json='product']");
    if (!jsonScript) {
      return false;
    }
    var prodData = JSON.parse(jsonScript.textContent);
    var handle = prodData.handle;
    popup.querySelector('h2').innerText = prodData.title;
    popup.querySelector('.prod-bg').style.backgroundImage = 'url(' + prodData.image + ')';
    popup.querySelector('.actions-content').innerHTML = prodData.actions;
    popup.querySelector('.btn').setAttribute('data-cart-add', prodData.variant_id);
    popup.querySelector('.btn').style.display = 'none';
    popup.querySelector('.full-details-link').setAttribute('href', '/products/' + handle);
    if (product.classList.contains('can-buy')) {
      popup.querySelector('.btn').style.display = 'block';
    }
    popup.classList.add('shown');
  }
  if (e.target && e.target.classList.contains('loyalty-trigger')) {
    e.preventDefault();
    var appTrigger = document.querySelector('#open-sesame');
    if (appTrigger) {
      var event = document.createEvent('HTMLEvents');
      event.initEvent('click', true, false);
      appTrigger.dispatchEvent(event);
    }
  }
});
var popupClick = function (e) {
  var clickedIgnore = hasParent(e.target, ['popup-inner']);
  if (!clickedIgnore) {
    popup.classList.remove('shown');
  }
};
popup.addEventListener('click', popupClick);
popupClose.addEventListener('click', function () {
  popup.classList.remove('shown');
});
var appLinkedElems = document.querySelectorAll('[data-completed-questionnaire]');
for (var i = 0; i < appLinkedElems.length; i += 1) {
  (function () {
    var elem = appLinkedElems[i];
    window.EmbassyQuestionnaire = window.EmbassyQuestionnaire || [];
    window.EmbassyQuestionnaire.push(function (api) {
      api.hasCompletedQuestionnaire().then(function (hasCompleted) {
        (function () {
          if (hasCompleted) {
            elem.classList.add('has-completed-questionnaire');
          } else {
            elem.classList.add('hasnt-completed-questionnaire');
          }
        })(elem);
      });
    });
  })(i);
}
var appLinkedElems = document.querySelectorAll('[data-hide-if-completed-analysis]');
for (var i = 0; i < appLinkedElems.length; i += 1) {
  (function () {
    var elem = appLinkedElems[i];
    window.EmbassyQuestionnaire = window.EmbassyQuestionnaire || [];
    window.EmbassyQuestionnaire.push(function (api) {
      api.hasCompletedQuestionnaire().then(function (hasCompleted) {
        (function (elem) {
          if (hasCompleted) {
            elem.classList.add('hide');
          }
        })(elem);
      });
    });
  })(i);
}
var appLinkedElems = document.querySelectorAll('[data-show-if-completed-analysis]');
for (var i = 0; i < appLinkedElems.length; i += 1) {
  (function () {
    var elem = appLinkedElems[i];
    window.EmbassyQuestionnaire = window.EmbassyQuestionnaire || [];
    window.EmbassyQuestionnaire.push(function (api) {
      api.hasCompletedQuestionnaire().then(function (hasCompleted) {
        (function (elem) {
          if (hasCompleted) {
            elem.classList.remove('hide');
          }
        })(elem);
      });
    });
  })(i);
}
var searchForms = document.querySelectorAll('form.search-form');
for (var i = 0; i < searchForms.length; i += 1) {
  (function () {
    var form = searchForms[i];
    form.addEventListener('submit', function () {
      var searchField = this.querySelector("input[name='q']");
      searchField.value = searchField.value.trim() + '*';
      return true;
    });
  })(i);
}

function getQueryVariable(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var urlAfterLoginOrRegisterEls = document.querySelectorAll('[data-checkout-url]');
document.addEventListener('DOMContentLoaded', function () {
  if (getQueryVariable('checkout_url')) {
    var url = getQueryVariable('checkout_url');
    localStorage.setItem('redirectURL', url);
    if (url) {
      for (var i = 0; i < urlAfterLoginOrRegisterEls.length; i += 1) {
        urlAfterLoginOrRegisterEls[i].value = url;
      }
    }
  }
});
var urlAfterRegisterEls = document.querySelectorAll('[data-checkout-url-register]');
document.addEventListener('DOMContentLoaded', function () {
  if (getQueryVariable('checkout_url_register')) {
    var url = getQueryVariable('checkout_url_register');
    localStorage.setItem('redirectURL', '/pages/members-area#/questionnaire');
    if (url) {
      for (var i = 0; i < urlAfterRegisterEls.length; i += 1) {
        urlAfterRegisterEls[i].value = url;
      }
    }
  }
});
var urlAfterLoginEls = document.querySelectorAll('[data-checkout-url-login]');
document.addEventListener('DOMContentLoaded', function () {
  if (getQueryVariable('checkout_url_login')) {
    var url = getQueryVariable('checkout_url_login');
    localStorage.setItem('redirectURL', url);
    if (url) {
      for (var i = 0; i < urlAfterLoginEls.length; i += 1) {
        urlAfterLoginEls[i].value = url;
      }
    }
  }
});
var urlElems = document.querySelectorAll('.url-elem');
for (var i = 0; i < urlElems.length; i += 1) {
  urlElems[i].addEventListener('click', function (e) {
    e.preventDefault();
    window.location = this.dataset.href;
  });
}
document.addEventListener('DOMContentLoaded', function () {
  var memberPageKeys = document.querySelectorAll('#eb-account-app .key-inner .key-items > div');
  if (memberPageKeys.length > 0) {
    document.addEventListener('click', keyToolTip);
    for (var i = 0; i < memberPageKeys.length; i += 1) {
      var key = memberPageKeys[i];
      key.addEventListener('click', function (e) {
        e.preventDefault();
        keyToolTip(e.currentTarget);
      });
    }
  }
});

function keyToolTip(active) {
  if (!document.querySelector('#eb-account-app .key-inner .key-items').contains(active.target)) {
    var memberPageKeys = document.querySelectorAll('#eb-account-app .key-inner .key-items > div');
    if (memberPageKeys.length > 0) {
      for (var i = 0; i < memberPageKeys.length; i += 1) {
        var key = memberPageKeys[i];
        key.classList.remove('selected-key');
      }
      if (active && !active.target) {
        active.classList.add('selected-key');
        document.querySelector('#eb-account-app .key-inner .key-items').classList.add('key-items--clicked');
      }
      if (active.target) {
        document.querySelector('#eb-account-app .key-inner .key-items').classList.remove('key-items--clicked');
      }
    }
  }
}
var createCustomerForm = document.querySelector('#create_customer');
var addedEmail = false;
if (createCustomerForm) {
  var mailchimpCheck = createCustomerForm.querySelector('#mailchimpAgree');
  createCustomerForm.addEventListener('submit', function (e) {
    if (!addedEmail && mailchimpCheck.checked) {
      e.preventDefault();
    }
    localStorage.setItem('formSubmitted', 'create_customer');
    if (getQueryVariable('return_to')) {
      localStorage.setItem('redirectURL', getQueryVariable('return_to'));
    } else {
      localStorage.setItem('redirectURL', createCustomerForm.querySelector("[name='return_to']").value);
    }
    if (!addedEmail && mailchimpCheck.checked) {
      addToMCList(createCustomerForm);
    }
  });
}

function addToMCList() {
  var realEmailInput = createCustomerForm.querySelector('#Email');
  var fakeEmailInput = createCustomerForm.querySelector('#mailChimpEmail');
  fakeEmailInput.value = realEmailInput.value;
  $.ajax({
    type: createCustomerForm.getAttribute('method'),
    url: createCustomerForm.getAttribute('data-mailchimp-url').replace('/post?', 'post-json?').concat('&c=?'),
    data: $(createCustomerForm).serialize(),
    dataType: 'jsonp',
    contentType: 'application/json; charset=utf-8',
    error: function (err) {
      alert('Could not connect to the registration server.');
    },
    success: function (data) {
      addedEmail = true;
      createCustomerForm.submit();
    },
  });
}
var loginForm = document.querySelector('#customer_login');
if (createCustomerForm) {
  loginForm.addEventListener('submit', function () {
    localStorage.setItem('formSubmitted', 'login_customer');
  });
}
$('[data-mailchimp-ajax]').submit(function (e) {
  e.preventDefault();
  var instance = this;
  $.ajax({
    type: instance.getAttribute('method'),
    url: instance.getAttribute('action').replace('/post?', '/post-json?').concat('&c=?'),
    data: $(instance).serialize(),
    dataType: 'jsonp',
    contentType: 'application/json; charset=utf-8',
    error: function (err) {
      alert('Could not connect to the registration server.');
    },
    success: function (data) {
      if (data.result != 'success') {
        instance.querySelector('[data-success]').innerHTML = data.msg;
      } else {
        instance.querySelector('[data-success]').innerHTML = 'Thank you for signing up.<br/>We have sent you a confirmation email';
      }
    },
  });
});
if ($('#g-recaptcha').length) {
  if (localStorage.getItem('redirectURL') && localStorage.getItem('formSubmitted') == 'create_customer') {
    var $newInput = $('<input type="hidden" name="return_to" value="' + localStorage.getItem('redirectURL') + '" />');
    $newInput.insertBefore($('.shopify-challenge__container input[type="submit"]'));
  }
}
(function () {
  var actionElems = document.querySelectorAll('[data-action]');
  for (var i = 0; i < actionElems.length; i += 1) {
    actionComp(actionElems[i]);
  }

  function actionComp(elem) {
    var actionObj = {};
    actionObj.data = JSON.parse(elem.getAttribute('data-action'));
    actionObj.elems = {
      elem: elem,
      on: actionObj.data.on ? document.querySelectorAll(actionObj.data.on) : null,
    };
    actionObj.elems.elem.addEventListener(actionObj.data.reactTo, function (e) {
      for (var i = 0; i < actionObj.elems.on.length; i += 1) {
        var currElem = actionObj.elems.on[i];
        currElem.click();
      }
    });
    return actionObj;
  }
  var checkRecommendedProducts = document.querySelectorAll('[data-r-products]');
  if (checkRecommendedProducts.length > 0) {
    for (var i = 0; i < checkRecommendedProducts.length; i += 1) {
      recommendedProducts(checkRecommendedProducts[i]);
    }
  }

  function recommendedProducts(elem) {
    var recProdObj = {};
    recProdObj.data = JSON.parse(elem.getAttribute('data-r-products'));
    if (!recProdObj.data) {
      return false;
    }
    recProdObj.endpoint = '//embassyofbeauty.eastsideco.io/frontend/api/v1/product-recommendations.json?id=' + recProdObj.data.id + '&email=' + recProdObj.data.email;
    $.getJSON(recProdObj.endpoint, function (data) {
      checkForRProducts(data.products);
    });

    function checkForRProducts(products) {
      for (var i = 0; i < products.length; i += 1) {
        var currProduct = products[i];
        var currProductElems = document.querySelectorAll('[data-handle="' + currProduct.product_handle + '"]');
        if (currProductElems.length > 0) {
          addRProductClass(currProductElems);
        }
      }
    }

    function addRProductClass(recProducts) {
      for (var i = 0; i < recProducts.length; i += 1) {
        var currProduct = recProducts[i];
        currProduct.classList.add('can-buy');
      }
    }
  }
})();

// SCF go to tab specfied in query string eg embassyofbeauty.co.uk/pages/brands?active-tab=ayuna
const params = new URLSearchParams(window.location.search);
if (params.has('active-tab')) {
  tabHandle = '.tab-area [data-handle=' + params.get('active-tab') + ']';
  document.querySelector(tabHandle).click();
}

$readMoreJS.init({
  target: '.collection-background--no-image .collection-background__subtext',
  charactersCount: 25, // Alternatively use `charactersCount` if you wish to truncate by characters' length.
  toggle: true,
  moreLink: 'Read more',
  lessLink: 'Read less',
});

const blogReadMore = document.querySelectorAll('.read-more-button');

blogReadMore.forEach((btn) => {
  btn.addEventListener('click', (e) => {
    console.log(e.target)
    const readMore = e.target.closest('.read-more')
    const truncDesc = readMore.querySelector('.truncated-desc')
    const fullDesc = readMore.querySelector('.full-desc')

    truncDesc.classList.toggle('active')
    fullDesc.classList.toggle('active')
  })
})